// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"YrfAei1","gigAttributeWrapper":"YrfAei1","gig-attribute":"dJajHU1","gigAttribute":"dJajHU1","attribute-text":"TeLlC9q","attributeText":"TeLlC9q"};